export const WithdrawalWaiverCheckbox = ({ checked, onChange, waiverText, testId = 'waiver-checkbox' }) => (
  <label className="flex items-start gap-2 cursor-pointer" data-testid={testId}>
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className="mt-0.5 w-4 h-4 rounded border-brand-border text-brand-green focus:ring-brand-green"
      required
      data-testid={`${testId}-input`}
    />
    <span className="text-xs text-brand-muted leading-relaxed">{waiverText}</span>
  </label>
);
